import ReqClient from './request.class'

// 获取落地页列表
export async function getLandPage(data) {
  const Req = new ReqClient({
    url: '/api/ptom/landpage/page',
    method: 'POST',
    data
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取落地页链接地址
export async function getLandPageUrl(params) {
  const Req = new ReqClient({
    url: '/api/ptom/plandata/getLandPageUrl',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取落地页详情
export async function getLandPageById(data) {
  const Req = new ReqClient({
    url: '/api/ptom/landpage/getNewPageInfoById',
    method: 'POST',
    data
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 添加/修改落地页
export async function addLandPage(data) {
  const Req = new ReqClient({
    url: '/api/ptom/landpage/addOrUpdateNewPage',
    method: 'POST',
    data
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 上传图片
export async function uploadImage(params) {
  const Req = new ReqClient({
    url: '/api/ptom/landpage/addNewPageMaterial',
    method: 'POST',
    params
  })
  try {
    return await Req.reqFormData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 刷新落地页
export async function refreshLandPage(params) {
  const Req = new ReqClient({
    url: '/api/ptom/landpage/refreshCdn',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取落地页包列表
export async function getLandingPagePackages(data) {
  const Req = new ReqClient({
    url: '/api/ptom/landPackagePackage/page',
    method: 'POST',
    data
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 新增落地页包列表
export async function addLandingPagePackage(data) {
  const Req = new ReqClient({
    url: '/api/ptom/landPackagePackage/add',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 更新落地页包列表
export async function updateLandingPagePackage(data) {
  const Req = new ReqClient({
    url: '/api/ptom/landPackagePackage/update',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}
